import React from 'react';
import cn from 'classnames';
import styles from './label.module.scss';

interface IProps {
  className?: string,
  htmlFor?: string,
  children: React.ReactNode,
}

export default function Label(props: IProps) {
  return (
    <label
      className={ cn(styles.formLabel, props.className) }
      htmlFor={ props.htmlFor }
    >
      { props.children }
    </label>
  );
}
